import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  dialogMinHeight: {
    minHeight: "220px",
  },
  inputBackgroundColor: {
    backgroundColor: "#F4F4F4",
  },
  buttonRoot: {
    height: "40px",
  },
  formHelperText: {
    marginLeft: "0px",
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  requiredText: {
    color: theme.palette.warning.main,
  },
}))

export default styles
